// import { ajax } from 'rxjs/ajax';
import { saveStackup as ajax } from './mock';

export function saveStackup(stackup) {
  return ajax({
    url: '/api/stackup',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: stackup,
  });
}

export default saveStackup;



// WEBPACK FOOTER //
// ./src/services/stackup.js